__webpack_require__.p = "https://loyalty-voltran.hepsiburada.com/project/assets/";